"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Program = require("./Program");

Object.defineProperty(exports, "Program", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Program).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }